/* Refillia: prima di aprire un sito esterno (per esempio i documenti su Google Drive) chiede conferma e apre una nuova scheda */
(function () {
  var velo = null, vai = null, ultimo = null;
  function crea() {
    velo = document.createElement('div');
    velo.className = 'rf-esce-velo';
    velo.hidden = true;
    velo.innerHTML = '<div class="rf-esce" role="dialog" aria-modal="true" aria-labelledby="rf-esce-t">' +
      '<div class="rf-esce__t"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg><h3 id="rf-esce-t">Apriamo i documenti su Google Drive</h3></div>' +
      '<p>Si aprono in una nuova scheda: Refillia resta aperto qui, con il tuo carrello.</p>' +
      '<div class="rf-esce__b"><a href="#" target="_blank" rel="noopener" data-rf-esce-vai>Apri Google Drive</a><button type="button" data-rf-esce-no>Resta qui</button></div></div>';
    document.body.appendChild(velo);
    vai = velo.querySelector('[data-rf-esce-vai]');
    vai.addEventListener('click', function () { setTimeout(chiudi, 50); });
    velo.querySelector('[data-rf-esce-no]').addEventListener('click', chiudi);
    velo.addEventListener('click', function (e) { if (e.target === velo) chiudi(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !velo.hidden) chiudi(); });
  }
  function chiudi() { velo.hidden = true; if (ultimo) ultimo.focus({ preventScroll: true }); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-rf-esce]');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    if (!velo) crea();
    ultimo = a;
    vai.href = a.href;
    velo.hidden = false;
    vai.focus({ preventScroll: true });
  });
})();
